module.exports = __webpack_public_path__ + "static/media/signal-alt-2.b5023aa9.svg";